// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0-NJs","body":"styles_body__tlxs7","migratePoints":"styles_migratePoints__MCjd+","slide-in-bottom":"styles_slide-in-bottom__n2Sua"};